import { CaretLeftIcon, CaretRightIcon } from '@panwds/icons';
import { classNames, twMerge } from '@panwds/tailwindcss';
import React, { useRef, useEffect, useState } from 'react';
import { Button } from '../Button/index.js';
export const ScrollButton = ({ onMouseDown, onKeyDown, onMouseUp, onKeyUp, onMouseLeave, direction = 'left', size = 'md', addClassName, activeTabId, ...rest }) => {
    const [hasLinearGradient, setHasLinearGradient] = useState(true);
    const ref = useRef(null);
    const sizeClasses = twMerge('twds-text-sm twds-leading-6 twds-h-8 twds-rounded-none hover:twds-bg-transparent', size === 'sm' && 'twds-text-xs twds-h-6', size === 'lg' && 'text-base twds-h-10', addClassName);
    const linearGradient = direction === 'left'
        ? `after:twds-bg-gradient-to-r after:twds-from-white
        dark:after:twds-from-gray-1050 after:twds-via-white/50
        after:twds-to-white/0 after:twds-pointer-events-none
        after:twds-h-8 after:twds-absolute after:twds-w-10
        after:twds-content-[''] after:twds-text-transparent
        after:twds-z-20`
        : `before:twds-bg-gradient-to-l before:twds-from-white
        dark:before:twds-from-gray-1050 before:twds-via-white/50
        before:twds-to-white/0 before:twds-pointer-events-none
        before:twds-h-8 before:twds-absolute before:twds-w-10
        before:twds-content-[''] before:twds-text-transparent
        before:twds-right-0 before:twds-z-20`;
    const Divider = () => {
        return (React.createElement("span", { className: classNames('twds-bg-gray-300 dark:twds-bg-gray-600 twds-h-6 twds-w-px twds-border-r twds-z-10 twds-basis-1/12 twds-self-center') }));
    };
    useEffect(() => {
        if (!activeTabId || !ref.current) {
            return;
        }
        const activeTab = document.getElementById(activeTabId);
        if (!activeTab) {
            return;
        }
        const container = ref.current;
        const checkGradientVisibility = (entries) => {
            entries.forEach((entry) => {
                if (direction === 'left') {
                    setHasLinearGradient(entry.boundingClientRect.left > container.getBoundingClientRect().left);
                }
                else {
                    setHasLinearGradient(entry.boundingClientRect.right < container.getBoundingClientRect().right - 1);
                }
            });
        };
        const observer = new IntersectionObserver(checkGradientVisibility, {
            root: null,
            threshold: 1.0
        });
        observer.observe(activeTab);
        return () => {
            observer.unobserve(activeTab);
            observer.disconnect();
        };
    }, [activeTabId, direction]);
    return (React.createElement("div", { className: classNames('twds-flex twds-items-center', direction === 'right' ? 'flex-row-reverse' : 'flex-row', 'hover:twds-bg-blue-100 dark:hover:twds-bg-gray-800 active:twds-bg-blue-200 dark:active:twds-bg-gray-700') },
        direction === 'right' && (React.createElement(React.Fragment, null,
            React.createElement("span", { ref: ref, className: classNames('twds-h-full twds-relative', hasLinearGradient && linearGradient) }),
            React.createElement(Divider, null))),
        React.createElement(Button, { addClassName: sizeClasses, appearance: "tertiary-clear", onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...rest }, direction === 'left' ? React.createElement(CaretLeftIcon, { size: "xs" }) : React.createElement(CaretRightIcon, { size: "xs" })),
        direction === 'left' && (React.createElement(React.Fragment, null,
            React.createElement(Divider, null),
            React.createElement("span", { ref: ref, className: classNames('twds-h-full twds-relative', hasLinearGradient && linearGradient) })))));
};
//# sourceMappingURL=ScrollButton.js.map